<template>
  <div class="border border-grey">
    Other Absences
  </div>
</template>
